var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintOrang2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2842_3423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2842_3423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 10.6667V6.66667H10.666V10.6667H7.99935V4H23.9993V10.6667H21.3327ZM23.9993 16.6667C24.3771 16.6667 24.6938 16.5389 24.9493 16.2833C25.2049 16.0278 25.3327 15.7111 25.3327 15.3333C25.3327 14.9556 25.2049 14.6389 24.9493 14.3833C24.6938 14.1278 24.3771 14 23.9993 14C23.6216 14 23.3049 14.1278 23.0493 14.3833C22.7938 14.6389 22.666 14.9556 22.666 15.3333C22.666 15.7111 22.7938 16.0278 23.0493 16.2833C23.3049 16.5389 23.6216 16.6667 23.9993 16.6667ZM21.3327 25.3333V20H10.666V25.3333H21.3327ZM23.9993 28H7.99935V22.6667H2.66602V14.6667C2.66602 13.5333 3.0549 12.5833 3.83268 11.8167C4.61046 11.05 5.5549 10.6667 6.66602 10.6667H25.3327C26.466 10.6667 27.416 11.05 28.1827 11.8167C28.9493 12.5833 29.3327 13.5333 29.3327 14.6667V22.6667H23.9993V28ZM26.666 20V14.6667C26.666 14.2889 26.5382 13.9722 26.2827 13.7167C26.0271 13.4611 25.7105 13.3333 25.3327 13.3333H6.66602C6.28824 13.3333 5.97157 13.4611 5.71602 13.7167C5.46046 13.9722 5.33268 14.2889 5.33268 14.6667V20H7.99935V17.3333H23.9993V20H26.666Z",
    fill: "#09c70794"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintOrang2);
export default __webpack_public_path__ + "static/media/printOrang2.23950d07edb6a97475f1986cafb3ee89.svg";
export { ForwardRef as ReactComponent };